import Image from "@/entities/image";

export default class News {
  id: number
  title: string
  slug?: string
  text_intro: string
  text_full: string
  status: number
  images: Array<number>
  thumbnail?: File // Sending the file
  news_thumbnail_image?: ThumbnailImage // Getting the file
  created_at?: string

  constructor (values: NewsConstructorValues) {
    this.id = values.id
    this.title = values.title
    this.slug = values.slug
    this.text_intro = values.text_intro
    this.text_full = values.text_full
    this.status = values.status
    this.images = values.images
    this.thumbnail = values.thumbnail
    this.news_thumbnail_image = values.news_thumbnail_image
    this.created_at = values.created_at

  }
}

export interface ThumbnailImage {
  id: number;
  micro_site_id: number;
  image_id: number;
  image: Image;
}

export interface NewsConstructorValues {
  id: number
  title: string
  slug?: string
  text_intro: string
  text_full: string
  status: number
  images: Array<number>
  thumbnail?: File
  news_thumbnail_image?: ThumbnailImage
  created_at?: string
}
